var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vue-form-generator',{ref:"vfg",attrs:{"schema":_vm.formSchema,"model":_vm.form,"options":_vm.formOptions},on:{"validated":_vm.formValidated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }